import pLimit from "p-limit";

/** Limits API fan-out while retaining each item's result for partial success and retries. */
export async function runBatch<Item, Value>(
  items: readonly Item[],
  concurrency: number,
  run: (item: Item) => Promise<Value>,
) {
  const limit = pLimit(concurrency);
  const results = await Promise.allSettled(
    items.map((item) => limit(() => run(item))),
  );
  const succeeded: { item: Item; value: Value }[] = [];
  const failed: { item: Item; error: unknown }[] = [];
  results.forEach((result, index) => {
    const item = items[index]!;
    if (result.status === "fulfilled")
      succeeded.push({ item, value: result.value });
    else failed.push({ item, error: result.reason });
  });
  return { succeeded, failed };
}
